export const detail = {
  table: {
    id: 'ID',
    companyId: 'Company ID',
    shortName: 'Short Name',
    companyName: 'Company Name',
    createdAt: 'Create Date',
    washingMethodName: 'Washing Method',
    time: 'Time',
  },
  tableWashingMethod: {
    title: 'Washing Program',
  },
  pageHeader: {
    title: 'Customers',
    titleCustomersList: 'Personal data registration/editing',
  },
}
